import { render } from "./collection-product-swatches.vue?vue&type=template&id=6af7f1dc&scoped=true"
import script from "./collection-product-swatches.vue?vue&type=script&lang=js"
export * from "./collection-product-swatches.vue?vue&type=script&lang=js"

import "./collection-product-swatches.vue?vue&type=style&index=0&id=6af7f1dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af7f1dc"]])

export default __exports__